module.exports = __webpack_public_path__ + "img/category-popular-hover.7aff946c.png";